import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Portifolio from "./views/Portifolio.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";

import Contact from "./views/Contact.vue";
import Article from "./views/Article.vue";
import ArticleById from "./views/ArticleById.vue";
import PageNotFound from "./views/PageNotFound.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/portifolio",
      name: "portifolio",
      components: {
        header: AppHeader,
        default: Portifolio,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      }
    },
    {
      path: "/articles",
      name: "Article",
      components: {
        header: AppHeader,
        default: Article,
        footer: AppFooter
      }
    },
    {
      path: "/articles/:id",
      name: "ArticleById",
      components: {
        header: AppHeader,
        default: ArticleById,
        footer: AppFooter
      }
    },
    {
      path: "*",
      name: "page not found",
      components: {
        header: AppHeader,
        default: PageNotFound,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
